const transition = {
  state: {
    isLoading: false,
    direction: 'forward',
    title: '',
    isNetLoading: false,
    toast: {
      type: 'text',
      loading: false,
      text: '',
      time: 1500
    },
    loadingCount: 0,
    topLeftMenus: {

    },
    titleMenus: {
      title: [],
      '/paperDetails': []
    },
    topRightMenus: {
      '/paperDetails': []
    },
    rateWH: Math.round(window.innerWidth * 100 / 320) / 100,
    timeOut: -1
  },
  mutations: {
    updateLoadingStatus: function (state, payload) {
      state.isLoading = payload.isLoading
    },
    updateNetLoadingStatus: function (state, payload) {
      payload.isLoading ? state.loadingCount += 1 : state.loadingCount -= 1
      state.isNetLoading = state.loadingCount !== 0
      state.netLoadingText = payload.text || ''
    },
    showToast: function (state, payload) {
      state.toast = {
        ...{
          type: 'text',
          loading: false,
          text: '',
          time: 1500
        },
        ...payload
      }
    },
    updateDirection: function (state, payload) {
      state.direction = payload.direction
    },
    updateTitle: function (state, payload) {
      state.title = payload.title
    },
    updateTitleMenus: function (state, payload) {
      state.titleMenus = { ...state.titleMenus, ...payload }
    },
    updateTopRightMenu: function (state, payload) {
      state.topRightMenus = { ...state.topRightMenus, ...payload }
    },
    updateTopLeftMenu: function (state, payload) {
      state.topLeftMenus = { ...state.topLeftMenus, ...payload }
    },
    updateRateWH: function (state, payload) {
      state.rateWH = payload.rateWH
    },
    updateTimeOut: function (state, payload) {
      // console.log('state.oldtimeOut=======' + state.timeOut)
      clearTimeout(state.timeOut)
      state.timeOut = payload
    }
  }
}

export default transition
